import { IForgotPassword, ILogin, ILoginResponse, ISignupReponse, IUser } from "types/models/Account";
import { apiGet, apiPost } from "utils/api";
import AuthenPaths from "./paths";


export const authLoginAPI = (data: any) => {
  return apiPost<ILoginResponse>(AuthenPaths.Login, data);
};

export const authUserAPI = () => {
  return apiGet<any>(AuthenPaths.Info);
};

export const signupAPI = (data: ILogin) => {
  const { username, password } = data;

  return apiPost<ISignupReponse>(AuthenPaths.Signup, { username, password });
};

export const forgotPasswordAPI = (data: any) => {
  return apiPost<IForgotPassword>(AuthenPaths.Forgot, data);
};

export const resetPasswordAPI = (data: any) => {
  return apiPost<IForgotPassword>(AuthenPaths.Reset, data);
};

export const authToken = (id: string | number) => {
  // return apiGet<IUser>();
}
